import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { exposeAppVersion } from '../lib/config';
import { initSentry } from '../lib/sentry';
import '../lib/lang/i18n';
import App from './App';

import '../styles/globals.css';

exposeAppVersion();
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
